<template>
  <div class="page-IntroDuction">
     <el-row style="height:10px"></el-row>
     <PageTemplate :topEmptyRowHeight="10" :bottomEmptyRowHeight="10">
      <el-row style="margin-left:180px">
        <el-col :span="6">
          <el-button  @click="Record('/find')" plain :round="true" :class="[activeMenu === '/find' ? 'active' : '']">图书检索系统 型号：HJ1</el-button>
        </el-col>
        <el-col :span="6">
          <el-button  @click="Record('/Jiehuan')" plain :round="true" :class="[activeMenu === '/Jiehuan' ? 'active' : '']">智能自助借还系统 型号：V3.0</el-button>
        </el-col>
        <el-col :span="6">
          <el-button  @click="Record('/Guanyuan')" plain :round="true" :class="[activeMenu === '/Guanyuan' ? 'active' : '']">馆员工作站系统 型号：HG3</el-button>
        </el-col>
        <el-col :span="6">
          <el-button  @click="Record('/SiShisan')" plain :round="true" :class="[activeMenu === '/SiShisan' ? 'active' : '']">安全门 型号：H418</el-button>
        </el-col>
      </el-row>
      <el-row style="height:10px"></el-row>
    </PageTemplate>
    <router-view></router-view>
    <el-row style="height:200px"></el-row>
    <Footer></Footer>
    <input id="focus" class="jujiao" type="text">
  </div>
</template>
<script>
import PageTemplate from '@/components/PageTemplate'
import Footer from '@/components/Footer'
export default {
  components:{PageTemplate, Footer},
  data () {
    return {
    }
  },
  methods : {
    Record (index) {
      document.getElementById("focus").focus()
      this.$router.push(`/introduction${index}`)
    }
  },
  computed: {
    activeMenu () { // 头部根菜单高亮和显示哪个模块的的菜单， 菜单的 serviceCode ===meta.rootActiveMenu 还有针对ROUTER_403、ROUTER_EMPTY使用active
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) { // 注意这里很重要
        return meta.activeMenu
      }
      return path
    }
  }
}
</script>
<style lang="scss">
.page-IntroDuction{
  background-color: rgb(243, 242, 242);
  .active {
    background-color:  #409EFF;
    color:white
  }
  .jujiao {
    opacity:0;
    position: absolute;
    top: 200px;
    left: -600px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/IntroDuction.vue